import { lastValueFrom } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListResponse, Result } from '@shared/models';
import { LoggerService } from '../services/logger.service';
import * as Entities from '@shared/entities';

@Injectable({
  providedIn: 'root',
})
export class RetailerNoteApi {
  private serviceUri = '';

  constructor(
    private http: HttpClient,
    private log: LoggerService,
    private config: ConfigService
  ) {
    this.config.Config.subscribe((config) => {
      if (config?.apiUri) {
        this.serviceUri = `${config.apiUri}/retailerNotes/`;
      }
    });
  }

  async loadNoteTypes(_force: boolean = false): Promise<ListResponse<Entities.NoteType>> {
    const result = await lastValueFrom(
      this.http.get<Result<ListResponse<Entities.NoteType>>>(this.serviceUri + 'note-types')
    );
    if (result.successful) {
      return result.data;
    }

    this.displayError('loadNoteTypes', result);
    return { records: [] } as ListResponse<Entities.NoteType>;
  }

  async delete(id: number): Promise<Result<number>> {
    const result = await lastValueFrom(this.http.delete<Result<number>>(this.serviceUri + 'note-types/' + id));
    console.debug('delete', result);
    if (!result.successful) {
      this.displayError('delete', result);
    }
    return result;
  }

  async create(program: Entities.NoteType): Promise<Result<number>> {
    const result = await lastValueFrom(this.http.post<Result<number>>(this.serviceUri + 'note-types', program));
    if (!result.successful) {
      console.debug('create', result);
    }
    return result;
  }

  async update(id: number, program: Entities.NoteType): Promise<Result<number>> {
    const result = await lastValueFrom(this.http.put<Result<number>>(this.serviceUri + 'note-types/' + id, program));
    if (!result.successful) {
      this.displayError('update', result);
    }
    return result;
  }

  private displayError<T>(source = 'source', result: Result<T>): void {
    this.log.displayError(result.message, source, result.data);
  }
}
